// Registers the PWA service worker — production only. The worker holds no cache
// at all (it only exists so the site stays installable as a PWA, and it wipes
// any caches left by older workers). On preview/dev we actively unregister any
// previously installed worker and wipe its caches.
// Skipped during react-snap prerendering so cached HTML never leaks
// into the static build.
export function registerServiceWorker() {
  if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) return;
  const ua = navigator.userAgent || "";
  if (/ReactSnap|Prerender/i.test(ua)) return;

  if (process.env.NODE_ENV !== "production") {
    window.addEventListener("load", () => {
      navigator.serviceWorker
        .getRegistrations()
        .then((rs) => rs.forEach((r) => r.unregister()))
        .catch(() => {});
      if (window.caches) {
        caches
          .keys()
          .then((ks) => ks.forEach((k) => caches.delete(k)))
          .catch(() => {});
      }
    });
    return;
  }

  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").catch(() => {
      /* registration is best-effort — never break the app */
    });
  });
}
